<template>
<div class="main" id="main" v-bind:class="[{ init: isInit}, frame]">

  <!-- First slide -->
  <div class="bg-one"></div>
  <svg class="text-one-digital" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 171.2 35.5" style="enable-background:new 0 0 171.2 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-one" d="M0,34.2V0.6h10.9c5.4,0,9.8,1.5,13.1,4.5c3.3,3,4.9,7.1,4.9,12.3c0,5.2-1.6,9.2-4.9,12.3s-7.6,4.5-13.1,4.5H0z
    		 M9.6,26.2h1.2c2.5,0,4.5-0.7,6-2.2c1.5-1.5,2.2-3.7,2.2-6.5c0-2.9-0.7-5.1-2.2-6.5c-1.5-1.5-3.5-2.2-6-2.2H9.6V26.2z"/>
    	<path class="fill-one" d="M30,34.2V0.6h9.6v33.6H30z"/>
    	<path class="fill-one" d="M58.5,34.8c-5.3,0-9.7-1.7-13-5c-3.3-3.3-5-7.5-5-12.5c0-4.9,1.7-9.1,5-12.4c3.3-3.3,7.7-5,13-5
    		c2.4,0,4.6,0.4,6.7,1.1c2.1,0.8,3.6,1.5,4.7,2.4c1,0.8,1.9,1.7,2.7,2.6l-6,6.1c-2-2.3-4.5-3.5-7.5-3.5c-2.5,0-4.6,0.8-6.1,2.4
    		c-1.6,1.6-2.4,3.7-2.4,6.2c0,2.5,0.8,4.6,2.4,6.3c1.6,1.6,3.8,2.5,6.4,2.5c3,0,5.1-0.5,6.4-1.6v-1.9h-5.4v-7.8h14.2v14.8
    		c-1.6,1.1-2.9,1.9-4,2.5c-1.1,0.6-2.7,1.2-4.9,1.8C63.4,34.6,61.1,34.8,58.5,34.8z"/>
    	<path class="fill-one" d="M76.1,34.2V0.6h9.6v33.6H76.1z"/>
    	<path class="fill-one" d="M93.3,34.2V9h-6.9V0.6h23.4V9h-7v25.2H93.3z"/>
    	<path class="fill-one" d="M126.7,27.8h-10.1l-2,6.4H105l11.6-33.6h10.1l11.6,33.6h-9.6L126.7,27.8z M124.5,20.2l-2.8-9.6l-2.8,9.6H124.5
    		z"/>
    	<path class="fill-one" d="M138.4,34.2V0.6h9.6v25.2h9.6v8.4H138.4z"/>
    	<path class="fill-one" d="M160.4,29.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.9-1.6s2.8,0.5,3.9,1.6c1,1,1.6,2.3,1.6,3.8
    		c0,1.5-0.5,2.7-1.6,3.7c-1,1-2.3,1.5-3.9,1.5s-2.8-0.5-3.9-1.5S160.4,31,160.4,29.6z"/>
    </g>
  </svg>
  <svg class="text-one-simple" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 159.5 35.5" style="enable-background:new 0 0 159.5 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-one" d="M0,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5C1.5,14.1,1,12.4,1,10.4c0-3.2,1.1-5.7,3.2-7.6
    		C6.3,0.9,9.1,0,12.6,0c1.8,0,3.5,0.3,4.9,0.9C19,1.4,20.1,2.2,21,3.1c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8s-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3c-1-0.9-1.7-1.8-2.3-2.6
    		C0.7,28.2,0.3,27.4,0,26.7z"/>
    	<path class="fill-one" d="M25.5,34.2V0.6h9.6v33.6H25.5z"/>
    	<path class="fill-one" d="M50.2,0.6l7.5,20l7.6-20h12.4v33.6h-9.1V13.8l-6.5,17.8h-8.7l-6.4-17.8v20.4h-9.2V0.6H50.2z"/>
    	<path class="fill-one" d="M80.4,34.2V0.6h13.1c3.6,0,6.3,1,8.3,3c2,2,3,4.7,3,8.2c0,3.3-1,6-3.1,8.1c-2,2.1-4.8,3.1-8.1,3.1h-3.7v11.1
    		H80.4z M89.9,15.1h2c1,0,1.8-0.3,2.3-0.9c0.5-0.6,0.8-1.4,0.8-2.4c0-0.9-0.3-1.7-0.8-2.3c-0.5-0.6-1.3-0.9-2.2-0.9h-2.1V15.1z"/>
    	<path class="fill-one" d="M105.5,34.2V0.6h9.6v25.2h9.6v8.4H105.5z"/>
    	<path class="fill-one" d="M125.1,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H125.1z"/>
    	<path class="fill-one" d="M148.5,29.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.9-1.6s2.8,0.5,3.9,1.6c1,1,1.6,2.3,1.6,3.8
    		c0,1.5-0.5,2.7-1.6,3.7c-1,1-2.3,1.5-3.9,1.5s-2.8-0.5-3.9-1.5S148.5,31,148.5,29.6z"/>
    </g>
  </svg>
  <svg class="text-one-radical" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 189 35.5" style="enable-background:new 0 0 189 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-one-2" d="M10.7,26.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.8,0.1-1.3,0.1v8.9H0V0.3h8.1c2,0,3.9,0.4,5.7,1.1
    		s3.3,1.6,4.6,2.8c1.3,1.2,2.4,2.6,3.1,4.1c0.8,1.6,1.1,3.2,1.1,5c0,1.9-0.4,3.6-1.2,5.2c-0.8,1.6-1.9,3-3.4,4.2l7.8,12.6h-9.6
    		L10.7,26.3z M8.1,18.4c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.6,2.1-1.1c0.6-0.4,1.1-1,1.4-1.6c0.3-0.6,0.5-1.2,0.5-1.9
    		c0-0.7-0.2-1.3-0.5-1.9c-0.3-0.6-0.8-1.1-1.4-1.5c-0.6-0.4-1.3-0.8-2.1-1.1C9.8,8.6,9,8.5,8.1,8.4V18.4z"/>
    	<path class="fill-one-2" d="M49.1,31.2H38l-1.4,4.3h-8.6l12-35.2h7.7L59,35.4h-8.5L49.1,31.2z M46.5,23l-2.8-8.5L40.8,23H46.5z"/>
    	<path class="fill-one-2" d="M68.6,0c2.3,0.1,4.5,0.7,6.6,1.7c2.1,1,3.9,2.3,5.4,3.9c1.5,1.6,2.7,3.5,3.6,5.6c0.9,2.1,1.3,4.4,1.3,6.8
    		c0,2.4-0.4,4.6-1.3,6.6c-0.9,2.1-2.1,3.9-3.6,5.4c-1.5,1.6-3.3,2.8-5.4,3.8c-2,0.9-4.3,1.5-6.7,1.6h-8.1V0L68.6,0L68.6,0z
    		 M68.6,27.3c1.2-0.1,2.4-0.5,3.5-1c1.1-0.5,2-1.2,2.8-2c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.7-2.2,0.7-3.5c0-1.2-0.2-2.4-0.7-3.6
    		c-0.4-1.1-1.1-2.1-1.9-3c-0.8-0.9-1.7-1.6-2.8-2.2c-1.1-0.6-2.2-0.9-3.5-1V27.3z"/>
    	<path class="fill-one-2" d="M94.4,35.4h-8.1V0.1h8.1V35.4z"/>
    	<path class="fill-one-2" d="M112.8,35.4c-2.3,0-4.5-0.4-6.6-1.3c-2.2-0.8-4.1-2.1-5.8-3.9c-1.7-1.7-2.9-3.6-3.8-5.7
    		c-0.9-2.1-1.3-4.4-1.3-6.7c0-2.4,0.4-4.7,1.3-6.8c0.9-2.1,2.2-4,3.8-5.7c1.7-1.7,3.7-3,5.9-3.9c2.2-0.9,4.4-1.3,6.6-1.3
    		c2.3,0,4.5,0.4,6.6,1.3c2.2,0.9,4.1,2.2,5.8,3.9l-5.7,5.7c-0.9-0.9-2-1.6-3.2-2.1c-1.2-0.5-2.4-0.7-3.6-0.7c-1.2,0-2.4,0.2-3.6,0.7
    		c-1.2,0.5-2.2,1.2-3.1,2.1c-0.9,0.9-1.6,2-2.1,3.1c-0.5,1.2-0.7,2.4-0.7,3.6c0,1.3,0.2,2.5,0.7,3.6c0.5,1.1,1.2,2.2,2.1,3.1
    		c0.9,0.9,2,1.6,3.1,2.1c1.2,0.5,2.4,0.7,3.6,0.7c1.2,0,2.4-0.2,3.6-0.7c1.2-0.5,2.2-1.2,3.2-2.1l5.7,5.8c-1.7,1.7-3.7,3-5.8,3.9
    		C117.4,35,115.1,35.4,112.8,35.4z"/>
    	<path class="fill-one-2" d="M145.3,31.2h-11.1l-1.4,4.3h-8.6l12-35.2h7.7l11.4,35.2h-8.5L145.3,31.2z M142.7,23l-2.8-8.5L137,23H142.7z"/>
    	<path class="fill-one-2" d="M178.2,35.4h-21V0.1h8.1v27.2h12.9V35.4z"/>
    	<path class="fill-one-2" d="M188.7,31.2c0,1.2-0.4,2.1-1.2,3c-0.8,0.8-1.8,1.2-3,1.2c-1.2,0-2.1-0.4-3-1.2c-0.8-0.8-1.2-1.8-1.2-3
    		c0-1.2,0.4-2.1,1.2-3c0.8-0.8,1.8-1.2,3-1.2c1.2,0,2.1,0.4,3,1.2C188.3,29.1,188.7,30.1,188.7,31.2z"/>
    </g>
  </svg>
  <img src="../img/bg-one-glass.png" class="elem-one" />

  <!-- Second slide -->
  <div class="bg-two"></div>
  <img src="../img/bg-two-boats.png" class="elem-two" />
  <svg class="text-two-deliver" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 35.5" style="enable-background:new 0 0 200 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-two" d="M0,34.2V0.6h10.9c5.4,0,9.8,1.5,13.1,4.5c3.3,3,4.9,7.1,4.9,12.3c0,5.2-1.6,9.2-4.9,12.3s-7.6,4.5-13.1,4.5H0z
    		 M9.6,26.2h1.2c2.5,0,4.5-0.7,6-2.2c1.5-1.5,2.2-3.7,2.2-6.5c0-2.9-0.7-5.1-2.2-6.5c-1.5-1.5-3.5-2.2-6-2.2H9.6V26.2z"/>
    	<path class="fill-two" d="M30,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H30z"/>
    	<path class="fill-two" d="M51,34.2V0.6h9.6v25.2h9.6v8.4H51z"/>
    	<path class="fill-two" d="M70.6,34.2V0.6h9.6v33.6H70.6z"/>
    	<path class="fill-two" d="M102.9,34.2H92.4L80.3,0.6h10.5l7,22.6l6.9-22.6h10.5L102.9,34.2z"/>
    	<path class="fill-two" d="M115.1,34.2V0.6H134V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H115.1z"/>
    	<path class="fill-two" d="M136.2,34.2V0.6H148c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5l-5.7-11.9h-1.7v11.9H136.2z M145.7,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-two" d="M193.9,35.7l-3.4-3.5c-2.3,1.7-5.2,2.6-8.7,2.6c-4.1,0-7.3-1-9.7-3.1s-3.6-4.7-3.6-7.8c0-3.6,1.8-6.7,5.5-9.3
    		c-1.3-1.9-2-3.8-2-5.7c0-2.7,1-4.8,2.9-6.5c1.9-1.6,4.5-2.5,7.6-2.5c3.4,0,6,0.9,7.9,2.6c1.9,1.7,2.8,3.9,2.8,6.6
    		c0,3.4-1.7,6.3-5,8.5l2.3,2.3c0.2-0.5,0.3-1.1,0.3-1.8h8.6c0,3.1-0.9,5.9-2.7,8.4l3.3,3.6L193.9,35.7z M181.7,26.7
    		c1.2,0,2.1-0.3,2.8-0.8l-5.2-5.4c-1,0.7-1.4,1.6-1.4,2.8c0,1.1,0.4,1.9,1.2,2.5C179.8,26.4,180.7,26.7,181.7,26.7z M180.3,9.5
    		c0,1.1,0.8,2.3,2.4,3.5c1.5-1.1,2.2-2.3,2.2-3.5c0-0.6-0.2-1.2-0.7-1.6c-0.4-0.4-1-0.6-1.8-0.6c-0.6,0-1.2,0.2-1.6,0.6
    		C180.5,8.3,180.3,8.8,180.3,9.5z"/>
    </g>
  </svg>
  <svg class="text-two-delight" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 171.1 35.5" style="enable-background:new 0 0 171.1 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-two-2" d="M8.1,0c2.3,0.1,4.5,0.7,6.6,1.7c2.1,1,3.9,2.3,5.4,3.9c1.5,1.6,2.7,3.5,3.6,5.6c0.9,2.1,1.3,4.4,1.3,6.8
    		c0,2.4-0.4,4.6-1.3,6.6c-0.9,2.1-2.1,3.9-3.6,5.4c-1.5,1.6-3.3,2.8-5.4,3.8c-2,0.9-4.3,1.5-6.7,1.6H0V0L8.1,0L8.1,0z M8.1,27.3
    		c1.2-0.1,2.4-0.5,3.5-1c1.1-0.5,2-1.2,2.8-2c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.7-2.2,0.7-3.5c0-1.2-0.2-2.4-0.7-3.6
    		c-0.4-1.1-1.1-2.1-1.9-3c-0.8-0.9-1.7-1.6-2.8-2.2c-1.1-0.6-2.2-0.9-3.5-1V27.3z"/>
    	<path class="fill-two-2" d="M34.3,8.3v5.3h11.8v8.1H34.3v5.6h14.5v8.1H26.2V0.2l22.6,0v8.1H34.3z"/>
    	<path class="fill-two-2" d="M73.6,35.4h-21V0.1h8.1v27.2h12.9V35.4z"/>
    	<path class="fill-two-2" d="M84,35.4h-8.1V0.1H84V35.4z"/>
    	<path class="fill-two-2" d="M116.5,15.7v19.7h-8.2v-0.9c-0.9,0.3-1.8,0.6-2.8,0.7c-0.9,0.1-1.9,0.2-2.8,0.2c-2.3,0-4.5-0.4-6.7-1.3
    		C94,33.3,92,32,90.3,30.3c-1.7-1.7-3-3.7-3.9-5.8c-0.8-2.2-1.3-4.4-1.3-6.6c0-2.3,0.4-4.5,1.3-6.7C87.3,9,88.6,7,90.3,5.3
    		c1.7-1.7,3.7-3,5.9-3.9c2.2-0.9,4.4-1.3,6.7-1.3c2.3,0,4.5,0.4,6.7,1.3c2.2,0.9,4.1,2.2,5.9,3.9l-5.8,5.8c-0.9-0.9-2-1.6-3.2-2.1
    		c-1.2-0.5-2.4-0.7-3.6-0.7c-1.2,0-2.4,0.2-3.6,0.7C98,9.4,97,10.1,96,11c-0.9,0.9-1.6,2-2.1,3.2c-0.5,1.2-0.7,2.4-0.7,3.6
    		c0,1.2,0.2,2.4,0.7,3.6c0.5,1.2,1.2,2.2,2.1,3.2c0.8,0.8,1.8,1.5,2.8,1.9c1,0.5,2.1,0.7,3.2,0.8c1.1,0.1,2.2,0,3.3-0.3
    		s2.1-0.8,3-1.4v-1.8h-7.1v-8.1H116.5z"/>
    	<path class="fill-two-2" d="M146.7,0.2v35.2h-8.1V22.1h-10.2v13.3h-8.1V0.2h8.1V14h10.2V0.2H146.7z"/>
    	<path class="fill-two-2" d="M171,8.2h-6.8v27.3h-8.1V8.2h-6.7V0H171V8.2z"/>
    </g>
  </svg>
  <svg class="text-two-deviate" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 640.6 35.5" style="enable-background:new 0 0 640.6 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-two" d="M0,34.2V0.6h10.9c5.4,0,9.8,1.5,13.1,4.5c3.3,3,4.9,7.1,4.9,12.3c0,5.2-1.6,9.2-4.9,12.3s-7.6,4.5-13.1,4.5H0z
    		 M9.6,26.2h1.2c2.5,0,4.5-0.7,6-2.2c1.5-1.5,2.2-3.7,2.2-6.5c0-2.9-0.7-5.1-2.2-6.5c-1.5-1.5-3.5-2.2-6-2.2H9.6V26.2z"/>
    	<path class="fill-two" d="M30.9,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H30.9z"/>
    	<path class="fill-two" d="M72.9,34.2H62.5L50.3,0.6h10.5l7,22.6l6.9-22.6h10.5L72.9,34.2z"/>
    	<path class="fill-two" d="M86.2,34.2V0.6h9.6v33.6H86.2z"/>
    	<path class="fill-two" d="M118.5,27.8h-10.1l-2,6.4h-9.6l11.6-33.6h10.1l11.6,33.6h-9.6L118.5,27.8z M116.2,20.2l-2.8-9.6l-2.8,9.6
    		H116.2z"/>
    	<path class="fill-two" d="M133.2,34.2V9h-6.9V0.6h23.4V9h-7v25.2H133.2z"/>
    	<path class="fill-two" d="M151.3,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H151.3z"/>
    	<path class="fill-two" d="M181,34.2V0.6h18.7V9h-9.1v4.7h7.9V22h-7.9v12.2H181z"/>
    	<path class="fill-two" d="M202.2,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5l-5.7-11.9h-1.7v11.9H202.2z M211.8,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-two" d="M258.8,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C263.8,22.4,262.1,26.6,258.8,29.9z M251.6,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3c1.5,1.6,3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5
    		c1.5-1.6,2.3-3.7,2.3-6.3C253.8,14.9,253.1,12.8,251.6,11.2z"/>
    	<path class="fill-two" d="M278.2,0.6l7.5,20l7.6-20h12.4v33.6h-9.1V13.8l-6.5,17.8h-8.7l-6.4-17.8v20.4h-9.2V0.6H278.2z"/>
    	<path class="fill-two" d="M321.9,34.2V9h-6.9V0.6h23.4V9h-7v25.2H321.9z"/>
    	<path class="fill-two" d="M340.1,34.2V0.6h9.6v12.6h10.7V0.6h9.6v33.6h-9.6V21.6h-10.7v12.6H340.1z"/>
    	<path class="fill-two" d="M373.5,34.2V0.6h18.8V9H383v4.1h7.8v8.3H383v4.5h9.6v8.4H373.5z"/>
    	<path class="fill-two" d="M432.8,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C437.8,22.4,436.1,26.6,432.8,29.9z M425.5,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3c1.5,1.6,3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5
    		c1.5-1.6,2.3-3.7,2.3-6.3C427.8,14.9,427,12.8,425.5,11.2z"/>
    	<path class="fill-two" d="M439.7,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5L451,22.4h-1.7v11.9H439.7z M449.3,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-two" d="M468.1,34.2V0.6h10.9c5.4,0,9.8,1.5,13.1,4.5c3.3,3,4.9,7.1,4.9,12.3c0,5.2-1.6,9.2-4.9,12.3
    		s-7.6,4.5-13.1,4.5H468.1z M477.7,26.2h1.2c2.5,0,4.5-0.7,6-2.2c1.5-1.5,2.2-3.7,2.2-6.5c0-2.9-0.7-5.1-2.2-6.5
    		c-1.5-1.5-3.5-2.2-6-2.2h-1.2V26.2z"/>
    	<path class="fill-two" d="M499,34.2V0.6h9.6v33.6H499z"/>
    	<path class="fill-two" d="M512.2,34.2V0.6h9.7l10.8,19.1V0.6h9.4v33.6h-9.5l-11.1-18.8v18.8H512.2z"/>
    	<path class="fill-two" d="M565,27.8h-10.1l-2,6.4h-9.6l11.6-33.6H565l11.6,33.6H567L565,27.8z M562.7,20.2l-2.8-9.6l-2.8,9.6H562.7z"/>
    	<path class="fill-two" d="M577.6,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5l-5.7-11.9h-1.7v11.9H577.6z M587.2,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-two" d="M614,34.2v-15L603.5,0.6h10.7l4.5,10.1l4.7-10.1h10.5l-10.4,18.6v15H614z"/>
    	<path class="fill-two" d="M629.7,29.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.9-1.6s2.8,0.5,3.9,1.6c1,1,1.6,2.3,1.6,3.8
    		c0,1.5-0.5,2.7-1.6,3.7c-1,1-2.3,1.5-3.9,1.5s-2.8-0.5-3.9-1.5S629.7,31,629.7,29.6z"/>
    </g>
  </svg>

  <!-- Third slide -->
  <div class="bg-three">
    <div class="bottom"></div>
  </div>
  <svg class="text-three-simplify" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 542.9 34.9" style="enable-background:new 0 0 542.9 34.9;" xml:space="preserve">
    <g>
    	<path class="fill-three" d="M0,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5C1.5,14.1,1,12.4,1,10.4c0-3.2,1.1-5.7,3.2-7.6
    		C6.3,0.9,9.1,0,12.6,0c1.8,0,3.5,0.3,4.9,0.9C19,1.4,20.1,2.2,21,3.1c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8c-2.1,2-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3
    		c-1-0.9-1.7-1.8-2.3-2.6C0.7,28.2,0.3,27.4,0,26.7z"/>
    	<path class="fill-three" d="M25.5,34.2V0.6h9.6v33.6H25.5z"/>
    	<path class="fill-three" d="M50.2,0.6l7.5,20l7.6-20h12.4v33.6h-9.1V13.8l-6.5,17.8h-8.7l-6.4-17.8v20.4h-9.2V0.6H50.2z"/>
    	<path class="fill-three" d="M80.4,34.2V0.6h13.1c3.6,0,6.3,1,8.3,3c2,2,3,4.7,3,8.2c0,3.3-1,6-3.1,8.1c-2,2.1-4.8,3.1-8.1,3.1h-3.7v11.1
    		H80.4z M89.9,15.1h2c1,0,1.8-0.3,2.3-0.9c0.5-0.6,0.8-1.4,0.8-2.4c0-0.9-0.3-1.7-0.8-2.3c-0.5-0.6-1.3-0.9-2.2-0.9h-2.1V15.1z"/>
    	<path class="fill-three" d="M105.5,34.2V0.6h9.6v25.2h9.6v8.4H105.5z"/>
    	<path class="fill-three" d="M125.1,34.2V0.6h9.6v33.6H125.1z"/>
    	<path class="fill-three" d="M137.4,34.2V0.6H156V9h-9.1v4.7h7.9V22h-7.9v12.2H137.4z"/>
    	<path class="fill-three" d="M165.5,34.2v-15L155.1,0.6h10.7l4.5,10.1L175,0.6h10.5l-10.4,18.6v15H165.5z"/>
    	<path class="fill-three" d="M197.3,34.2V9h-6.9V0.6h23.4V9h-7v25.2H197.3z"/>
    	<path class="fill-three" d="M243.6,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C248.6,22.4,247,26.6,243.6,29.9z M236.4,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3s3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5c1.5-1.6,2.3-3.7,2.3-6.3
    		C238.7,14.9,237.9,12.8,236.4,11.2z"/>
    	<path class="fill-three" d="M281.8,31.1c-2.6,2.5-6.2,3.8-10.8,3.8s-8.2-1.3-10.8-3.8c-2.6-2.5-3.8-5.8-3.8-10V0.6h9.6v20.5
    		c0,1.6,0.5,2.8,1.4,3.7c0.9,0.9,2.2,1.4,3.7,1.4c1.6,0,2.8-0.5,3.7-1.4c0.9-0.9,1.4-2.2,1.4-3.7V0.6h9.6v20.4
    		C285.6,25.2,284.4,28.6,281.8,31.1z"/>
    	<path class="fill-three" d="M288.3,34.2V0.6h9.7l10.8,19.1V0.6h9.4v33.6h-9.5l-11.1-18.8v18.8H288.3z"/>
    	<path class="fill-three" d="M319.3,17.4c0-4.9,1.7-9.1,5-12.4c3.3-3.3,7.7-5,13-5c4,0,7.4,1,10.2,2.9l-2.6,8.4c-2-1.7-4.4-2.5-7.1-2.5
    		c-2.5,0-4.6,0.8-6.1,2.4c-1.6,1.6-2.4,3.7-2.4,6.2c0,2.5,0.8,4.6,2.4,6.3c1.6,1.6,3.6,2.5,6.1,2.5c2.7,0,5-0.8,7.1-2.5l2.6,8.4
    		c-2.8,1.9-6.2,2.9-10.2,2.9c-5.3,0-9.7-1.7-13-5C321,26.5,319.3,22.3,319.3,17.4z"/>
    	<path class="fill-three" d="M377.5,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C382.5,22.4,380.8,26.6,377.5,29.9z M370.2,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3s3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5c1.5-1.6,2.3-3.7,2.3-6.3
    		C372.5,14.9,371.7,12.8,370.2,11.2z"/>
    	<path class="fill-three" d="M401.6,34.2h-10.4L379,0.6h10.5l7,22.6l6.9-22.6h10.5L401.6,34.2z"/>
    	<path class="fill-three" d="M413.9,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H413.9z"/>
    	<path class="fill-three" d="M434.9,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5l-5.7-11.9h-1.7v11.9H434.9z M444.4,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-three" d="M474,34.2V9h-6.9V0.6h23.4V9h-7v25.2H474z"/>
    	<path class="fill-three" d="M491.2,34.2V0.6h9.6v12.6h10.7V0.6h9.6v33.6h-9.6V21.6h-10.7v12.6H491.2z"/>
    	<path class="fill-three" d="M523.6,34.2V0.6h18.8V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H523.6z"/>
    </g>
  </svg>
  <svg class="text-three-extra" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 143 34.9" style="enable-background:new 0 0 143 34.9;" xml:space="preserve">
    <g>
    	<path class="fill-three-2" d="M0,34.2V0.6h18.8V9H9.6v4.1h7.8v8.3H9.6v4.5h9.6v8.4H0z"/>
    	<path class="fill-three-2" d="M21.3,34.2l10.6-16.8L21.3,0.6h11.2l5,9.5l5-9.5h11.2L43.1,17.4l10.7,16.8H43.1l-5.6-9.8l-5.7,9.8H21.3z"/>
    	<path class="fill-three-2" d="M61.6,34.2V9h-6.9V0.6h23.4V9h-7v25.2H61.6z"/>
    	<path class="fill-three-2" d="M81.7,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1H98.6L93,22.4h-1.7v11.9H81.7z M91.2,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8c0.6-0.6,0.9-1.3,0.9-2.2
    		c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-three-2" d="M131.1,27.8h-10.1l-2,6.4h-9.6l11.6-33.6h10.1l11.6,33.6h-9.6L131.1,27.8z M128.9,20.2l-2.8-9.6l-2.8,9.6
    		H128.9z"/>
    </g>
  </svg>
  <svg class="text-three-ordinary" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 226.4 35.6" style="enable-background:new 0 0 226.4 35.6;" xml:space="preserve">
    <g>
    	<path class="fill-three-2" d="M17.6,0.2c2.4,0,4.7,0.5,6.9,1.4c2.1,0.9,4,2.2,5.6,3.8s2.9,3.4,3.8,5.6c0.9,2.1,1.4,4.4,1.4,6.9
    		c0,2.4-0.5,4.7-1.4,6.9c-0.9,2.1-2.2,4-3.8,5.6s-3.5,2.8-5.6,3.8c-2.1,0.9-4.4,1.4-6.9,1.4s-4.7-0.5-6.9-1.4
    		c-2.1-0.9-4-2.2-5.6-3.8s-2.8-3.4-3.8-5.6C0.5,22.6,0,20.3,0,17.9c0-2.4,0.5-4.7,1.4-6.9c0.9-2.1,2.2-4,3.8-5.6s3.4-2.8,5.6-3.8
    		C12.9,0.7,15.2,0.2,17.6,0.2z M17.6,27.4c1.3,0,2.5-0.2,3.7-0.7c1.2-0.5,2.2-1.2,3-2c0.9-0.9,1.5-1.9,2-3c0.5-1.2,0.7-2.4,0.7-3.7
    		c0-1.3-0.2-2.5-0.7-3.7c-0.5-1.2-1.2-2.2-2-3c-0.9-0.9-1.9-1.5-3-2c-1.2-0.5-2.4-0.7-3.7-0.7c-1.3,0-2.5,0.2-3.7,0.7s-2.2,1.2-3,2
    		c-0.9,0.9-1.5,1.9-2,3c-0.5,1.2-0.7,2.4-0.7,3.7c0,1.3,0.2,2.5,0.7,3.7c0.5,1.2,1.2,2.2,2,3c0.9,0.9,1.9,1.5,3,2
    		S16.3,27.4,17.6,27.4z"/>
    	<path class="fill-three-2" d="M48,26.4c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.8,0.1-1.3,0.1v8.9h-8.1V0.4h8.1c2,0,3.9,0.4,5.7,1.1
    		s3.3,1.6,4.6,2.8c1.3,1.2,2.4,2.6,3.1,4.1c0.8,1.6,1.1,3.2,1.1,5c0,1.9-0.4,3.6-1.2,5.2c-0.8,1.6-1.9,3-3.4,4.2l7.8,12.6h-9.6
    		L48,26.4z M45.5,18.5c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.6,2.1-1.1c0.6-0.4,1.1-1,1.4-1.6c0.3-0.6,0.5-1.2,0.5-1.9
    		c0-0.7-0.2-1.3-0.5-1.9c-0.3-0.6-0.8-1.1-1.4-1.5C49.4,9.6,48.8,9.3,48,9c-0.8-0.3-1.6-0.4-2.5-0.5V18.5z"/>
    	<path class="fill-three-2" d="M74.9,0.1c2.3,0.1,4.5,0.7,6.6,1.7c2.1,1,3.9,2.3,5.4,3.9c1.5,1.6,2.7,3.5,3.6,5.6c0.9,2.1,1.3,4.4,1.3,6.8
    		c0,2.4-0.4,4.6-1.3,6.6c-0.9,2.1-2.1,3.9-3.6,5.4c-1.5,1.6-3.3,2.8-5.4,3.8c-2,0.9-4.3,1.5-6.7,1.6h-8.1V0.1L74.9,0.1L74.9,0.1z
    		 M74.9,27.4c1.2-0.1,2.4-0.5,3.5-1c1.1-0.5,2-1.2,2.8-2c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.7-2.2,0.7-3.5c0-1.2-0.2-2.4-0.7-3.6
    		c-0.4-1.1-1.1-2.1-1.9-3c-0.8-0.9-1.7-1.6-2.8-2.2c-1.1-0.6-2.2-0.9-3.5-1V27.4z"/>
    	<path class="fill-three-2" d="M100.6,35.5h-8.1V0.2h8.1V35.5z"/>
    	<path class="fill-three-2" d="M132.3,0.3v35.2h-8.8L112,15v20.5h-8.1V0.4h8.8l11.5,20.5V0.3H132.3z"/>
    	<path class="fill-three-2" d="M155.3,31.2h-11.1l-1.4,4.3h-8.6l12-35.2h7.7l11.4,35.2h-8.5L155.3,31.2z M152.7,23.1l-2.8-8.5l-2.9,8.5H152.7
    		z"/>
    	<path class="fill-three-2" d="M178.1,26.4c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.8,0.1-1.3,0.1v8.9h-8.1V0.4h8.1c2,0,3.9,0.4,5.7,1.1
    		s3.3,1.6,4.6,2.8c1.3,1.2,2.4,2.6,3.1,4.1c0.8,1.6,1.1,3.2,1.1,5c0,1.9-0.4,3.6-1.2,5.2c-0.8,1.6-1.9,3-3.4,4.2l7.8,12.6h-9.6
    		L178.1,26.4z M175.5,18.5c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.6,2.1-1.1c0.6-0.4,1.1-1,1.4-1.6c0.3-0.6,0.5-1.2,0.5-1.9
    		c0-0.7-0.2-1.3-0.5-1.9c-0.3-0.6-0.8-1.1-1.4-1.5c-0.6-0.4-1.3-0.8-2.1-1.1c-0.8-0.3-1.6-0.4-2.5-0.5V18.5z"/>
    	<path class="fill-three-2" d="M207.3,25.5L195.2,0h9l7.2,15.3L217.6,0h8.8L212,35.5h-8.8L207.3,25.5z"/>
    </g>
  </svg>
  <img src="../img/bg-three-pineapple.png" class="elem-three" />

  <!-- Fourth slide -->
  <svg class="text-four-mind" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 106 35.5" style="enable-background:new 0 0 106 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-four" d="M34.2,0.1l2.1,35.3h-8.1L27.3,21l-4.9,14.4h-8.1l-5.2-15l-1,15H0L2.3,0.1h8.4l7.7,22.1l7.5-22.1H34.2z"/>
    	<path class="fill-four" d="M45.8,35.4h-8.1V0.1h8.1V35.4z"/>
    	<path class="fill-four" d="M77.6,0.2v35.2h-8.8L57.3,14.9v20.5h-8.1V0.3H58l11.5,20.5V0.2H77.6z"/>
    	<path class="fill-four" d="M89,0c2.3,0.1,4.5,0.7,6.6,1.7c2.1,1,3.9,2.3,5.4,3.9c1.5,1.6,2.7,3.5,3.6,5.6c0.9,2.1,1.3,4.4,1.3,6.8
    		c0,2.4-0.4,4.6-1.3,6.6c-0.9,2.1-2.1,3.9-3.6,5.4c-1.5,1.6-3.3,2.8-5.4,3.8c-2,0.9-4.3,1.5-6.7,1.6h-8.1V0L89,0L89,0z M89,27.3
    		c1.2-0.1,2.4-0.5,3.5-1c1.1-0.5,2-1.2,2.8-2c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.7-2.2,0.7-3.5c0-1.2-0.2-2.4-0.7-3.6
    		c-0.4-1.1-1.1-2.1-1.9-3c-0.8-0.9-1.7-1.6-2.8-2.2c-1.1-0.6-2.2-0.9-3.5-1V27.3z"/>
    </g>
  </svg>
  <svg class="text-four-tickling" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 191.3 35.5" style="enable-background:new 0 0 191.3 35.5;" xml:space="preserve">
    <g>
    	<path class="fill-four" d="M21.6,8.1h-6.8v27.3H6.7V8.1H0V0h21.6V8.1z"/>
    	<path class="fill-four" d="M32.3,35.4h-8.1V0.1h8.1V35.4z"/>
    	<path class="fill-four" d="M50.7,35.3c-2.3,0-4.5-0.4-6.6-1.3c-2.2-0.8-4.1-2.1-5.8-3.9c-1.7-1.7-2.9-3.6-3.8-5.7
    		c-0.9-2.1-1.3-4.4-1.3-6.7c0-2.4,0.4-4.7,1.3-6.8c0.9-2.1,2.2-4,3.8-5.7c1.7-1.7,3.7-3,5.9-3.9C46.3,0.5,48.5,0,50.8,0
    		c2.3,0,4.5,0.4,6.6,1.3c2.2,0.9,4.1,2.2,5.8,3.9l-5.7,5.7c-0.9-0.9-2-1.6-3.2-2.1c-1.2-0.5-2.4-0.7-3.6-0.7c-1.2,0-2.4,0.2-3.6,0.7
    		C46,9.3,44.9,10,44,10.9c-0.9,0.9-1.6,2-2.1,3.1c-0.5,1.2-0.7,2.4-0.7,3.6c0,1.3,0.2,2.5,0.7,3.6c0.5,1.1,1.2,2.2,2.1,3.1
    		c0.9,0.9,2,1.6,3.1,2.1c1.2,0.5,2.4,0.7,3.6,0.7c1.2,0,2.4-0.2,3.6-0.7c1.2-0.5,2.2-1.2,3.2-2.1l5.7,5.8c-1.7,1.7-3.7,3-5.8,3.9
    		C55.3,34.9,53,35.3,50.7,35.3z"/>
    	<path class="fill-four" d="M77.5,17.8l18.1,17.6H83.9L72.5,24.3v11.1h-8.1V0.1h8.1v11.1L83.9,0.1h11.7L77.5,17.8z"/>
    	<path class="fill-four" d="M116.2,35.4h-21V0.1h8.1v27.2h12.9V35.4z"/>
    	<path class="fill-four" d="M126.6,35.4h-8.1V0.1h8.1V35.4z"/>
    	<path class="fill-four" d="M158.4,0.1v35.2h-8.8L138,14.8v20.5h-8.1V0.2h8.8l11.5,20.5V0.1H158.4z"/>
    	<path class="fill-four" d="M191.2,15.6v19.7h-8.2v-0.9c-0.9,0.3-1.8,0.6-2.8,0.7c-0.9,0.1-1.9,0.2-2.8,0.2c-2.3,0-4.5-0.4-6.7-1.3
    		c-2.2-0.9-4.1-2.2-5.9-3.9c-1.7-1.7-3-3.7-3.9-5.8c-0.8-2.2-1.3-4.4-1.3-6.6c0-2.3,0.4-4.5,1.3-6.7c0.8-2.2,2.1-4.1,3.9-5.9
    		c1.7-1.7,3.7-3,5.9-3.9c2.2-0.9,4.4-1.3,6.7-1.3c2.3,0,4.5,0.4,6.7,1.3c2.2,0.9,4.1,2.2,5.9,3.9l-5.8,5.8c-0.9-0.9-2-1.6-3.2-2.1
    		c-1.2-0.5-2.4-0.7-3.6-0.7c-1.2,0-2.4,0.2-3.6,0.7c-1.2,0.5-2.2,1.2-3.2,2.1c-0.9,0.9-1.6,2-2.1,3.2c-0.5,1.2-0.7,2.4-0.7,3.6
    		c0,1.2,0.2,2.4,0.7,3.6c0.5,1.2,1.2,2.2,2.1,3.2c0.8,0.8,1.8,1.5,2.8,1.9c1,0.5,2.1,0.7,3.2,0.8c1.1,0.1,2.2,0,3.3-0.3
    		s2.1-0.8,3-1.4v-1.8H176v-8.1H191.2z"/>
    </g>
  </svg>
  <svg class="text-four-ideas" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 501.1 43.1" style="enable-background:new 0 0 501.1 43.1;" xml:space="preserve">
    <g>
    	<path class="fill-four-2" d="M0,34.2V0.6h9.6v33.6H0z"/>
    	<path class="fill-four-2" d="M12.2,34.2V0.6h10.9c5.4,0,9.8,1.5,13.1,4.5c3.3,3,4.9,7.1,4.9,12.3c0,5.2-1.6,9.2-4.9,12.3s-7.6,4.5-13.1,4.5
    		H12.2z M21.8,26.2H23c2.5,0,4.5-0.7,6-2.2c1.5-1.5,2.2-3.7,2.2-6.5c0-2.9-0.7-5.1-2.2-6.5c-1.5-1.5-3.5-2.2-6-2.2h-1.2V26.2z"/>
    	<path class="fill-four-2" d="M42.2,34.2V0.6H61V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H42.2z"/>
    	<path class="fill-four-2" d="M82.3,27.8H72.2l-2,6.4h-9.6L72.2,0.6h10.1l11.6,33.6h-9.6L82.3,27.8z M80.1,20.2l-2.8-9.6l-2.8,9.6H80.1z"/>
    	<path class="fill-four-2" d="M91.8,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5c-0.9-1.5-1.4-3.2-1.4-5.2c0-3.2,1.1-5.7,3.2-7.6
    		C98.1,0.9,101,0,104.4,0c1.8,0,3.5,0.3,4.9,0.9c1.4,0.6,2.6,1.3,3.5,2.3c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8s-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3c-1-0.9-1.7-1.8-2.3-2.6
    		C92.5,28.2,92.1,27.4,91.8,26.7z"/>
    	<path class="fill-four-2" d="M115.8,29.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.9-1.6c1.6,0,2.9,0.5,3.9,1.5c1.1,1,1.6,2.4,1.6,4.3
    		c0,2.6-0.6,5.1-1.9,7.4c-1.2,2.3-2.9,4.2-5,5.5l-3.6-3.9c0.8-0.5,1.6-1.2,2.3-2c0.8-0.8,1.2-1.6,1.4-2.3c-1.3-0.3-2.4-1-3.1-1.9
    		C116.2,31.8,115.8,30.8,115.8,29.6z"/>
    	<path class="fill-four-2" d="M164.2,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C169.2,22.4,167.5,26.6,164.2,29.9z M157,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3c1.5,1.6,3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5
    		c1.5-1.6,2.3-3.7,2.3-6.3C159.2,14.9,158.5,12.8,157,11.2z"/>
    	<path class="fill-four-2" d="M170.2,34.2V0.6h9.7l10.8,19.1V0.6h9.4v33.6h-9.5l-11.1-18.8v18.8H170.2z"/>
    	<path class="fill-four-2" d="M214.5,34.2V9h-6.9V0.6H231V9h-7v25.2H214.5z"/>
    	<path class="fill-four-2" d="M231.7,34.2V0.6h9.6v12.6h10.7V0.6h9.6v33.6h-9.6V21.6h-10.7v12.6H231.7z"/>
    	<path class="fill-four-2" d="M264.1,34.2V0.6H283V9h-9.3v4.1h7.8v8.3h-7.8v4.5h9.6v8.4H264.1z"/>
    	<path class="fill-four-2" d="M291.9,34.2V0.6h9.6v12.6h10.7V0.6h9.6v33.6h-9.6V21.6h-10.7v12.6H291.9z"/>
    	<path class="fill-four-2" d="M353.9,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C358.9,22.4,357.3,26.6,353.9,29.9z M346.7,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3c1.5,1.6,3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5
    		c1.5-1.6,2.3-3.7,2.3-6.3C349,14.9,348.2,12.8,346.7,11.2z"/>
    	<path class="fill-four-2" d="M364.4,34.2V9h-6.9V0.6h23.4V9h-7v25.2H364.4z"/>
    	<path class="fill-four-2" d="M386.1,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5c-0.9-1.5-1.4-3.2-1.4-5.2c0-3.2,1.1-5.7,3.2-7.6
    		c2.1-1.9,4.9-2.8,8.4-2.8c1.8,0,3.5,0.3,4.9,0.9c1.4,0.6,2.6,1.3,3.5,2.3c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8s-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3c-1-0.9-1.7-1.8-2.3-2.6
    		C386.8,28.2,386.4,27.4,386.1,26.7z"/>
    	<path class="fill-four-2" d="M411.6,34.2V0.6h13.1c3.6,0,6.3,1,8.3,3c2,2,3,4.7,3,8.2c0,3.3-1,6-3.1,8.1c-2,2.1-4.8,3.1-8.1,3.1h-3.7v11.1
    		H411.6z M421.2,15.1h2c1,0,1.8-0.3,2.3-0.9c0.5-0.6,0.8-1.4,0.8-2.4c0-0.9-0.3-1.7-0.8-2.3c-0.5-0.6-1.3-0.9-2.2-0.9h-2.1V15.1z"/>
    	<path class="fill-four-2" d="M466.4,29.9c-3.3,3.3-7.7,5-13.2,5c-5.4,0-9.8-1.7-13.2-5c-3.3-3.3-5-7.5-5-12.5c0-5,1.7-9.1,5-12.4
    		s7.7-5,13.2-5c5.4,0,9.8,1.7,13.2,5c3.3,3.3,5,7.4,5,12.4C471.4,22.4,469.7,26.6,466.4,29.9z M459.2,11.2c-1.5-1.6-3.5-2.4-5.9-2.4
    		c-2.4,0-4.4,0.8-5.9,2.4s-2.3,3.7-2.3,6.2c0,2.5,0.8,4.6,2.3,6.3c1.5,1.6,3.5,2.5,5.9,2.5c2.4,0,4.4-0.8,5.9-2.5
    		c1.5-1.6,2.3-3.7,2.3-6.3C461.4,14.9,460.7,12.8,459.2,11.2z"/>
    	<path class="fill-four-2" d="M476.9,34.2V9H470V0.6h23.4V9h-7v25.2H476.9z"/>
    	<path class="fill-four-2" d="M490.1,29.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.9-1.6s2.8,0.5,3.9,1.6c1,1,1.6,2.3,1.6,3.8
    		c0,1.5-0.5,2.7-1.6,3.7c-1,1-2.3,1.5-3.9,1.5s-2.8-0.5-3.9-1.5S490.1,31,490.1,29.6z"/>
    </g>
  </svg>
  <img src="../img/bg-four-balloon.png" class="elem-four" />

  <!-- Fifth slide -->
  <svg class="text-five-lets" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 305.2 34.9" style="enable-background:new 0 0 305.2 34.9;" xml:space="preserve">
    <g>
    	<path class="fill-five" d="M0,34.2V0.6h9.6v25.2h9.6v8.4H0z"/>
    	<path class="fill-five" d="M19.6,34.2V0.6h18.8V9h-9.3v4.1H37v8.3h-7.8v4.5h9.6v8.4H19.6z"/>
    	<path class="fill-five" d="M45.6,34.2V9h-6.9V0.6h23.4V9h-7v25.2H45.6z"/>
    	<path class="fill-five" d="M62.2,13.7L61.9,0.6h7.3L69,13.7H62.2z"/>
    	<path class="fill-five" d="M68.9,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5c-0.9-1.5-1.4-3.2-1.4-5.2c0-3.2,1.1-5.7,3.2-7.6
    		C75.2,0.9,78,0,81.5,0c1.8,0,3.5,0.3,4.9,0.9c1.4,0.6,2.6,1.3,3.5,2.3c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8s-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3c-1-0.9-1.7-1.8-2.3-2.6
    		C69.5,28.2,69.1,27.4,68.9,26.7z"/>
    	<path class="fill-five" d="M98.9,26.7l8-3.9c0.5,0.9,1.2,1.7,2.1,2.4c0.9,0.6,1.7,1,2.5,1c1.4,0,2.1-0.5,2.1-1.5c0-0.6-0.5-1.2-1.4-1.7
    		c-0.9-0.5-2.1-1.1-3.4-1.7c-1.3-0.6-2.7-1.3-4-2.1c-1.3-0.8-2.5-2-3.4-3.5c-0.9-1.5-1.4-3.2-1.4-5.2c0-3.2,1.1-5.7,3.2-7.6
    		c2.1-1.9,4.9-2.8,8.4-2.8c1.8,0,3.5,0.3,4.9,0.9c1.4,0.6,2.6,1.3,3.5,2.3c0.9,0.9,1.5,1.8,2,2.6s0.8,1.6,1.1,2.4l-7.9,3.6
    		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.4-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1,0.1-1.3,0.4
    		c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.7,0.5,1.3,1.4,1.8c0.9,0.6,2.1,1.1,3.5,1.7c1.4,0.6,2.7,1.2,4.1,2c1.3,0.8,2.5,1.8,3.4,3.2
    		c0.9,1.4,1.4,3,1.4,4.9c0,3.3-1.1,6-3.2,8s-5.1,3-8.9,3c-1.9,0-3.6-0.3-5.1-0.9c-1.5-0.6-2.8-1.4-3.7-2.3c-1-0.9-1.7-1.8-2.3-2.6
    		C99.6,28.2,99.2,27.4,98.9,26.7z"/>
    	<path class="fill-five" d="M129.4,34.2V9h-6.9V0.6h23.4V9h-7v25.2H129.4z"/>
    	<path class="fill-five" d="M146.6,34.2V0.6h11.9c4.1,0,7.2,0.9,9.2,2.8c2.1,1.9,3.1,4.5,3.1,7.8c0,1.9-0.4,3.6-1.2,5.2
    		c-0.8,1.6-1.9,2.8-3.3,3.7l7.7,14.1h-10.5l-5.7-11.9h-1.7v11.9H146.6z M156.1,14.6h1.6c1.1,0,1.9-0.3,2.4-0.8
    		c0.6-0.6,0.9-1.3,0.9-2.2c0-2-1.1-2.9-3.3-2.9h-1.6V14.6z"/>
    	<path class="fill-five" d="M193.1,27.8h-10.1l-2,6.4h-9.6l11.6-33.6h10.1l11.6,33.6h-9.6L193.1,27.8z M190.9,20.2l-2.8-9.6l-2.8,9.6
    		H190.9z"/>
    	<path class="fill-five" d="M204.9,34.2V0.6h9.6v33.6H204.9z"/>
    	<path class="fill-five" d="M233.4,34.8c-5.3,0-9.7-1.7-13-5c-3.3-3.3-5-7.5-5-12.5c0-4.9,1.7-9.1,5-12.4c3.3-3.3,7.7-5,13-5
    		c2.4,0,4.6,0.4,6.7,1.1c2.1,0.8,3.6,1.5,4.7,2.4c1,0.8,1.9,1.7,2.7,2.6l-6,6.1c-2-2.3-4.5-3.5-7.5-3.5c-2.5,0-4.6,0.8-6.1,2.4
    		c-1.6,1.6-2.4,3.7-2.4,6.2c0,2.5,0.8,4.6,2.4,6.3c1.6,1.6,3.8,2.5,6.4,2.5c3,0,5.1-0.5,6.4-1.6v-1.9h-5.4v-7.8h14.2v14.8
    		c-1.6,1.1-2.9,1.9-4,2.5c-1.1,0.6-2.7,1.2-4.9,1.8C238.3,34.6,236,34.8,233.4,34.8z"/>
    	<path class="fill-five" d="M251,34.2V0.6h9.6v12.6h10.7V0.6h9.6v33.6h-9.6V21.6h-10.7v12.6H251z"/>
    	<path class="fill-five" d="M288.4,34.2V9h-6.9V0.6h23.4V9h-7v25.2H288.4z"/>
    </g>
  </svg>
  <svg class="text-five-talk" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 109.6 34.9" style="enable-background:new 0 0 109.6 34.9;" xml:space="preserve">
    <g>
    	<path class="fill-five-2" d="M6.9,34.2V9H0V0.6h23.4V9h-7v25.2H6.9z"/>
    	<path class="fill-five-2" d="M43.2,27.8H33.1l-2,6.4h-9.6L33.1,0.6h10.1l11.6,33.6h-9.6L43.2,27.8z M40.9,20.2l-2.8-9.6l-2.8,9.6H40.9z"/>
    	<path class="fill-five-2" d="M57.7,34.2V0.6h9.6v25.2h9.6v8.4H57.7z"/>
    	<path class="fill-five-2" d="M80.3,34.2V0.6h9.6v13.4l8.7-13.4h10.6L98,16.7l11.6,17.5H98.6l-8.8-13.7v13.7H80.3z"/>
    </g>
  </svg>
  <svg class="text-five-results" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 183.4 36.7" style="enable-background:new 0 0 183.4 36.7;" xml:space="preserve">
    <g>
    	<path class="fill-five-3" d="M10.7,26.9C10.2,26.9,9.8,27,9.4,27c-0.4,0-0.8,0.1-1.3,0.1V36H0V0.9h8.1c2,0,3.9,0.4,5.7,1.1
    		c1.8,0.7,3.3,1.6,4.6,2.8C19.7,6,20.8,7.4,21.5,9c0.8,1.6,1.1,3.2,1.1,5c0,1.9-0.4,3.6-1.2,5.2c-0.8,1.6-1.9,3-3.4,4.2L25.9,36
    		h-9.6L10.7,26.9z M8.1,18.9c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.6,2.1-1.1c0.6-0.4,1.1-1,1.4-1.6c0.3-0.6,0.5-1.2,0.5-1.9
    		c0-0.7-0.2-1.3-0.5-1.9c-0.3-0.6-0.8-1.1-1.4-1.5c-0.6-0.4-1.3-0.8-2.1-1.1C9.8,9.2,9,9,8.1,9V18.9z"/>
    	<path class="fill-five-3" d="M37,8.9v5.3h11.8v8.1H37v5.6h14.5V36H28.9V0.8l22.6,0v8.1H37z"/>
    	<path class="fill-five-3" d="M66.1,36.7c-1.1,0-2.2-0.2-3.3-0.5s-2.2-0.8-3.1-1.4c-1.7-1.1-3.1-2.6-4-4.3s-1.4-3.7-1.4-5.8h8.1
    		c0,1,0.2,1.7,0.6,2.2c0.4,0.5,0.8,0.9,1.1,1.1c0.6,0.4,1.2,0.6,1.9,0.6c0.7,0,1.3-0.1,2-0.4c0.4-0.2,0.8-0.4,1.1-0.7
    		c0.3-0.3,0.5-0.6,0.6-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0-0.3,0-0.5,0-0.6s0-0.4,0-0.6c0-0.3-0.1-0.5-0.3-0.8c-0.1-0.3-0.4-0.6-0.6-0.8
    		c-0.3-0.3-0.6-0.5-1.1-0.7c-0.4-0.2-0.7-0.3-1.1-0.4c-0.4-0.1-0.8-0.3-1.3-0.4c-0.8-0.3-1.6-0.5-2.5-0.9c-0.9-0.3-1.7-0.8-2.6-1.3
    		c-1.1-0.7-2.1-1.6-2.8-2.6c-0.8-1.1-1.3-2.2-1.7-3.4c-0.3-1.2-0.4-2.5-0.3-3.8C55.7,8,56,6.8,56.6,5.6c0.6-1.1,1.3-2,2.2-2.8
    		c0.9-0.8,1.8-1.4,2.9-1.9c1.1-0.5,2.2-0.7,3.4-0.8c1.2-0.1,2.4,0,3.7,0.3c1.2,0.3,2.3,0.7,3.3,1.4c1,0.6,1.8,1.4,2.6,2.3
    		c0.7,0.9,1.3,1.9,1.6,3c0.4,1.1,0.6,2.2,0.6,3.4h-8.1c0-0.7-0.2-1.2-0.7-1.5c-0.5-0.3-0.9-0.5-1.2-0.6c-0.1,0-0.2,0-0.5-0.1
    		c-0.2,0-0.5,0-0.8,0c-0.3,0-0.6,0.2-0.9,0.3c-0.3,0.2-0.6,0.5-0.8,0.8c-0.3,0.5-0.3,1-0.1,1.6c0.2,0.6,0.5,1,1,1.3
    		c0.4,0.3,0.9,0.5,1.5,0.7c0.5,0.2,1.1,0.4,1.7,0.6c0.5,0.2,1.1,0.3,1.7,0.5c0.6,0.2,1.1,0.4,1.7,0.7c2.1,1,3.7,2.4,4.9,4.2
    		c1.2,1.9,1.8,3.9,1.8,6.2c0,2.2-0.6,4.3-1.8,6.1c-1.2,1.9-2.8,3.3-4.9,4.2c-0.8,0.4-1.7,0.7-2.5,0.8C67.9,36.6,67,36.7,66.1,36.7z"
    		/>
    	<path class="fill-five-3" d="M94.8,36c-1.8,0-3.5-0.3-5.1-1c-1.6-0.7-3-1.6-4.3-2.8c-1.3-1.3-2.3-2.7-3-4.3c-0.7-1.6-1-3.3-1.1-5.1v-22h8.1
    		v22c0,1.4,0.5,2.6,1.6,3.7c1.1,1,2.3,1.5,3.7,1.5c0.7,0,1.4-0.1,2-0.4c0.6-0.3,1.2-0.7,1.7-1.2c0.5-0.5,0.8-1,1.1-1.7
    		c0.3-0.6,0.4-1.3,0.4-2.1V0.7h8.1v21.8c0,1.8-0.3,3.6-1,5.2c-0.7,1.6-1.6,3.1-2.8,4.3c-1.2,1.2-2.6,2.2-4.2,2.9
    		C98.5,35.6,96.8,36,95,36H94.8z"/>
    	<path class="fill-five-3" d="M113,36V0.7h8.1v27.2H134V36H113z"/>
    	<path class="fill-five-3" d="M157.5,8.7h-6.8V36h-8.1V8.7h-6.7V0.6h21.6V8.7z"/>
    	<path class="fill-five-3" d="M171.5,36.7c-1.1,0-2.2-0.2-3.3-0.5c-1.1-0.3-2.2-0.8-3.1-1.4c-1.7-1.1-3.1-2.6-4-4.3s-1.4-3.7-1.4-5.8h8.1
    		c0,1,0.2,1.7,0.6,2.2c0.4,0.5,0.8,0.9,1.1,1.1c0.6,0.4,1.2,0.6,1.9,0.6c0.7,0,1.3-0.1,2-0.4c0.4-0.2,0.8-0.4,1.1-0.7
    		c0.3-0.3,0.5-0.6,0.6-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0-0.3,0-0.5,0-0.6s0-0.4,0-0.6c0-0.3-0.1-0.5-0.3-0.8c-0.1-0.3-0.4-0.6-0.6-0.8
    		c-0.3-0.3-0.6-0.5-1.1-0.7c-0.4-0.2-0.7-0.3-1.1-0.4c-0.4-0.1-0.8-0.3-1.3-0.4c-0.8-0.3-1.6-0.5-2.5-0.9c-0.9-0.3-1.7-0.8-2.6-1.3
    		c-1.1-0.7-2.1-1.6-2.8-2.6c-0.8-1.1-1.3-2.2-1.7-3.4c-0.3-1.2-0.4-2.5-0.3-3.8c0.1-1.3,0.5-2.5,1.1-3.7c0.6-1.1,1.3-2,2.2-2.8
    		c0.9-0.8,1.8-1.4,2.9-1.9c1.1-0.5,2.2-0.7,3.4-0.8c1.2-0.1,2.4,0,3.7,0.3c1.2,0.3,2.3,0.7,3.3,1.4s1.8,1.4,2.6,2.3
    		c0.7,0.9,1.3,1.9,1.6,3c0.4,1.1,0.6,2.2,0.6,3.4h-8.1c0-0.7-0.2-1.2-0.7-1.5s-0.9-0.5-1.2-0.6c-0.1,0-0.2,0-0.5-0.1s-0.5,0-0.8,0
    		c-0.3,0-0.6,0.2-0.9,0.3c-0.3,0.2-0.6,0.5-0.8,0.8c-0.3,0.5-0.3,1-0.1,1.6c0.2,0.6,0.5,1,1,1.3c0.4,0.3,0.9,0.5,1.5,0.7
    		c0.5,0.2,1.1,0.4,1.7,0.6c0.5,0.2,1.1,0.3,1.7,0.5c0.6,0.2,1.1,0.4,1.7,0.7c2.1,1,3.7,2.4,4.9,4.2c1.2,1.9,1.8,3.9,1.8,6.2
    		c0,2.2-0.6,4.3-1.8,6.1c-1.2,1.9-2.8,3.3-4.9,4.2c-0.8,0.4-1.7,0.7-2.5,0.8C173.2,36.6,172.3,36.7,171.5,36.7z"/>
    </g>
  </svg>
  <img src="../img/bg-five-hole.png" class="elem-five" />
  <img src="../img/bg-five-banana.png" class="elem-five-2" />

  <div class="bullets">
    <ul>
      <li @click="setSlide(0)"><span></span><span></span></li>
      <li></li>
      <li @click="setSlide(1)"><span></span><span></span></li>
      <li></li>
      <li @click="setSlide(2)"><span></span><span></span></li>
      <li></li>
      <li @click="setSlide(3)"><span></span><span></span></li>
      <li></li>
      <li @click="setSlide(4)"><span></span><span></span></li>
    </ul>
  </div>

  <div class="next" @click="nextPage()"><span class="text">{{nextButton[index]}}</span><span class="discover">Discover</span></div>

</div>
</template>

<script>
var jQuery = require('jquery-easing')

var focus = true
var slideTransitionTime = 6000

export default {
  name: 'main',
  data() {
    return {
      isInit: false,
      frame: '',
      slides: ['one', 'two', 'three', 'four', 'five'],
      nextButton: ['Home', 'Clients', 'Services', 'About', 'Contact'],
      index: 0
    }
  },
  methods: {
    setSlide: function(slide) {
      // Reset auto slider
      clearInterval(window.sliderInterval)
      window.sliderInterval = null
      // Goto slide
      this.doSlideTransition(slide)
    },
    floatThis: function(element) {
      jQuery(window).bind('mousemove', function(e) {
        var moveX = -(e.pageX - jQuery(window).width() / 2) / 12
        var moveY = -(e.pageY - jQuery(window).height() / 2) / 12
        jQuery(element).css({
          'transform': 'translate(' + moveX + 'px,' + moveY + 'px)'
        })
      })
      jQuery(element).addClass('ease')
    },
    doSlideTransition: function(slide) {
      var main = this
      // Reset jquery events
      jQuery('.elem-two, .elem-five-2').attr('style', '').removeClass('ease')
      jQuery(window).unbind('mousemove')
      if (slide != 3) {
        jQuery('.elem-four.float').on('webkitAnimationIteration', function() {
          jQuery('.elem-four').removeClass('float').off('webkitAnimationIteration')
        })
      }
      // Discover button animation
      jQuery('.next .text').addClass('swim')
      var discoverTimer = setTimeout(function() {
        jQuery('.next .text').removeClass('swim')
      }, 450)
      var discoverButtonTimer = setTimeout(function() {
        jQuery('.next .text').html(main.nextButton[slide])
      }, 225)
      // Add jquery events
      switch (slide) {
        case 1:
          var bulletTimer = setTimeout(function() {
            main.floatThis(jQuery('.elem-two'))
          }, 1500)
          break
        case 3:
          var bulletTimer = setTimeout(function() {
            jQuery('.elem-four').addClass('float')
          }, 2100)
          break
        case 4:
          var bulletTimer = setTimeout(function() {
            main.floatThis(jQuery('.elem-five-2'))
          }, 1500)
          break
      }
      // Add class to main
      this.frame = this.slides[slide]
    },
    nextPage: function() {
      var main = this

      switch (this.frame) {
        case 'two':
          main.$router.push('/clients')
          break
        case 'three':
          main.$router.push('/services')
          break
        case 'four':
          main.$router.push('/about')
          break
        case 'five':
          main.$router.push('/contact')
          break
      }
    },
    windowFocus: function() {
      var main = this
      jQuery(window).one('focus', function() {
        if (!window.sliderInterval) {
          window.sliderInterval = setInterval(function() {
            if (window.homeIndex < main.slides.length - 1) window.homeIndex++
              else window.homeIndex = 0
            main.doSlideTransition(window.homeIndex)
          }, slideTransitionTime)
        }
        main.windowBlur()
      })
    },
    windowBlur: function() {
      var main = this
      jQuery(window).one('blur', function() {
        clearInterval(window.sliderInterval)
        window.sliderInterval = null
        //main.windowFocus()
        main.windowBlur()
      })
    }
  },
  beforeMount() {
    this.index = window.homeIndex
  },
  mounted() {
    var main = this

    var mountTimer = setTimeout(function() {
      main.isInit = true
      main.frame = main.slides[window.homeIndex]

      // Start slider
      if (document.hasFocus()) {
        if (!window.sliderInterval) {
          window.sliderInterval = setInterval(function() {
            if (window.homeIndex < main.slides.length - 1) window.homeIndex++
              else window.homeIndex = 0
            main.doSlideTransition(window.homeIndex)
          }, slideTransitionTime)
        }
        main.windowBlur()
      } else {
        main.windowFocus()
      }

      // Mobile section
      document.getElementById('main').addEventListener('touchstart', handleTouchStart, false)
      document.getElementById('main').addEventListener('touchmove', handleTouchMove, false)
      var xDown = null
      var yDown = null

      function handleTouchStart(evt) {
        xDown = evt.touches[0].clientX
        yDown = evt.touches[0].clientY
        // Stop slider
        clearInterval(window.sliderInterval)
        window.sliderInterval = null
      }

      function handleTouchMove(evt) {
        if (!xDown || !yDown) {
          return;
        }
        var xUp = evt.touches[0].clientX
        var yUp = evt.touches[0].clientY
        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            /* left swipe */
            if (window.homeIndex < main.slides.length - 1) window.homeIndex++
              else window.homeIndex = 0
            main.doSlideTransition(window.homeIndex)
          } else {
            /* right swipe */
            if (window.homeIndex > 0) window.homeIndex--
              else window.homeIndex = 4
            main.doSlideTransition(window.homeIndex)
          }
        } else {
          if (yDiff > 0) {
            /* up swipe */
          } else {
            /* down swipe */
          }
        }
        xDown = null
        yDown = null
      }

      // pixel init
      this.$analytics.fbq.event('PageView')
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?77b5acb1